export type ConnectionEvent = {
  id: string;
  name: string;
  slug: string;
  timeStart: string;
  timeEnd: string;
} | null;

export type Connection = {
  id: string;
  firstName: string;
  lastName: string;
  headline: string | null;
  email: string | null;
  websiteUrl: string | null;
  twitterUrl: string | null;
  linkedinUrl: string | null;
  imageUrl: string | null;
  event: ConnectionEvent;
};

export type ConnectionsStatus = 'idle' | 'processing' | 'success' | 'failed';

export type RegisteredEventOption = {
  id: string;
  name: string;
};

export type SelectedRegisteredEvent = {
  value: string;
  name: string;
};

export type RegisteredEventsFilterState = {
  options: RegisteredEventOption[];
  selectedEvent?: SelectedRegisteredEvent;
  searchText?: string;
  hasInitialised: boolean;
  hasMoreOptions: boolean;
  endCursor: string | null;
  status: ConnectionsStatus;
  error: { message: string } | null;
};

export type ConnectionsListState = {
  items: Connection[];
  pageInfo: {
    hasNextPage: boolean;
    endCursor: string | null;
  };
  status: ConnectionsStatus;
  error: { message: string } | null;
  activeEventId: string | null;
  eventFilter: RegisteredEventsFilterState;
};

export const defaultConnectionsState: ConnectionsListState = {
  items: [],
  pageInfo: { hasNextPage: false, endCursor: null },
  status: 'idle',
  error: null,
  activeEventId: null,
  eventFilter: {
    options: [],
    selectedEvent: undefined,
    searchText: undefined,
    hasInitialised: false,
    hasMoreOptions: false,
    endCursor: null,
    status: 'idle',
    error: null,
  },
};
